import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { observer } from 'mobx-react';
import RecordPresentationSelection from '../components/RecordPresentation/RecordPresentationSelection';
import NewRecordPresentation from '../components/RecordPresentation/NewRecordPresentation';
const RecordPresentationPage = ({ usersStore, mode, videoPresentationStore, assessmentsStore, companyStore, meetingStore }) => {

    return (
        <Switch>
            <Route
                exact
                path="/record-presentation"
                render={() => (
                    <RecordPresentationSelection meetingStore={meetingStore} companyStore={companyStore} />
                )}
            />
            <Route
                path="/record-presentation/:recordingType"
                render={() => (
                    <NewRecordPresentation
                        videoPresentationStore={videoPresentationStore}
                        usersStore={usersStore}
                        mode={mode}
                        assessmentsStore={assessmentsStore}
                        companyStore={companyStore}
                        meetingStore={meetingStore}
                    />
                )}
            />
            <Redirect from="/record-presentation/*" to="/record-presentation" />
        </Switch>
    );
};

export default observer(RecordPresentationPage);
